<template>
  <div>
    <PC v-if="isPc" :token="token" :profileUrl="profileUrl" :baseUrl="baseUrl" @showMask="showMask" :translateLists="translateLists" :isHedgehood="isHedgehood" :sendAvatar="sendAvatar" :unreadCount="unreadCount" :ticketAdd="ticketAdd" :ticketId="ticketId" :inHelpCenter="inHelpCenter" @toHelpCenter="toHelpCenter" @resetUnreadCount="resetUnreadCount"></PC>
    <Mobile v-else :token="token" :profileUrl="profileUrl" :baseUrl="baseUrl" @showMask="showMask" :translateLists="translateLists" :isHedgehood="isHedgehood" :sendAvatar="sendAvatar" :unreadCount="unreadCount" :ticketAdd="ticketAdd" :ticketId="ticketId" :inHelpCenter="inHelpCenter" @toHelpCenter="toHelpCenter" @resetUnreadCount="resetUnreadCount"></Mobile>
  </div>
</template>

<script>
import PC from "./components/pc.vue";
import Mobile from './components/mobile.vue';
export default {
  name: 'ChatBox',
  props:{
    token: {
      type: String,
      default: '',
    },
    profileUrl: {
      type: String,
      default: '',
    },
    baseUrl: {
      type: String,
      default: '',
    },
    translateLists: {
      type: Array
    },
    isHedgehood: {
      type: Boolean,
      default: false
    },
    sendAvatar: {
      type: String,
      default: ''
    },
    unreadCount: {
      type: Number,
      default: 0
    },
    ticketAdd: {
      type: Number,
      default: 0,
    },
    ticketId: {
      type: Number,
      default: 0,
    },
    inHelpCenter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PC,
    Mobile
  },
  data () {
    return {
      isPc: false
    }
  },
  created(){
    if (this.IsPC()) {
      this.isPc = true;
    } else {
      this.isPc = false;
    }
    console.log(this.isPc)
  },
  methods: {
    toHelpCenter() {
      this.$emit('toHelpCenter');
    },
    resetUnreadCount() {
      this.$emit('resetUnreadCount');
    },
    // showMask
    showMask(value) {
      this.$emit('showMask', value);
    },
    // 设备判断
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/packages/chatBox/index.vue